var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("tr", [
    _c(
      "td",
      { staticStyle: { width: "16px" } },
      [
        _c("q-icon", {
          staticClass: "drag-item-handle",
          attrs: { name: "drag_indicator", color: "grey-7" }
        })
      ],
      1
    ),
    _c("td", { staticClass: "text-left" }, [
      _vm._v(_vm._s(_vm.lineItem.itemName))
    ]),
    _c("td", { staticClass: "text-right text-no-wrap" }, [
      _vm._v(_vm._s(_vm.quantityFormatted))
    ]),
    _c("td", { staticClass: "text-right text-no-wrap" }, [
      _vm._v(_vm._s(_vm.priceFormatted))
    ]),
    _vm.showDiscount
      ? _c("td", { staticClass: "text-right text-no-wrap" }, [
          _vm._v(_vm._s(_vm.discountString))
        ])
      : _vm._e(),
    _c("td", { staticClass: "text-right text-no-wrap" }, [
      _vm._v(_vm._s(_vm.salesTaxFormatted))
    ]),
    _c("td", { staticClass: "text-right text-no-wrap" }, [
      _vm._v(_vm._s(_vm.sumFormatted))
    ]),
    _c(
      "td",
      { staticClass: "text-right text-no-wrap" },
      [
        _c("q-btn", {
          attrs: { icon: "edit", color: "grey-6", flat: "", dense: "" },
          on: { click: _vm.handleEdit }
        }),
        _c("q-btn", {
          staticClass: "q-ml-sm",
          attrs: { icon: "delete", color: "grey-6", flat: "", dense: "" },
          on: { click: _vm.handleDelete }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }